export const ACTIVATE_IDNOW = 'page/ACTIVATE_IDNOW';
export const CONTINUE_IDNOW_LINK = 'page/CONTINUE_IDNOW_LINK';
